import axios from 'axios'
import React from 'react'
import { baseUrl } from '../../assets/Animations'
import './family-card.css'
import {gql, useMutation } from '@apollo/client';
import WrongLessonLengthWarningPopup from './WrongLessonLengthWarningPopup/WrongLessonLengthWarningPopup';

const FamilyCard = (props) => {

    const [manuallyEnterFamilyName, setManuallyEnterFamilyName] = React.useState(false)
    const [manuallyEnterStudentName, setManuallyEnterStudentName] = React.useState(false)
    const [familyNameSuggestions, setFamilyNameSuggestions] = React.useState([])
    const [searchName, setSearchName] = React.useState('')
    const [familyInfoPopup, setFamilyInfoPopup] = React.useState(false)
    const [familyInfoPopupData, setFamilyInfoPopupData] = React.useState([])
    const [repeatLesson, setRepeatLesson] = React.useState(false)
    const [lengthWarningPopup, setLengthWarningPopup] = React.useState(false)

    let CREATE_CUSTOMER = gql`mutation ($input: CustomerCreateInput!) {
        customerCreate(input: $input) {
          didSucceed
          inputErrors {
            code
            message
            path
          }
          customer {
            id
            name
            firstName
            lastName
            email
            address {
              addressLine1
              addressLine2
              city
              province {
                code
                name
              }
              country {
                code
                name
              }
              postalCode
            }
            currency {
              code
            }
          }
        }
      }`    
    const [createCustomer] = useMutation(CREATE_CUSTOMER)

    const myToken = localStorage.getItem('token')
    const myHeader = {
        headers: { Authorization: `Bearer ${myToken}` }
    }

    React.useEffect(() => {
        if(props.reviewing) {
            //generateTeacherFilterList()
            if(document.getElementById(`family-selector-${props.fam.id}`)) {
                document.getElementById(`family-selector-${props.fam.id}`).value === '---' ? document.getElementById(`family-selector-${props.fam.id}`).style.color = 'red' : document.getElementById(`family-selector-${props.fam.id}`).style.color = "#000"
            }
        } else {
            //generateTeacherFilterListForTeachers()
        }
        //ALLOW TEACHER TO MANUALLY ENTER THE NAME OF THE FAMILY
        if(props.fam.familyName === '*') {
            switchToManualFamilyNameInput()
        }
        //CHECK FOR TEACHER LOGGING LESSONS/CANCELLATIONS AT THE SAME TIME
        checkForRepeatLessons()
    })

    const switchToManualFamilyNameInput = () => {
        props.changeFamilyName(props.index, '')
        setManuallyEnterFamilyName(true)
    }

    const checkForRepeatLessons = () => {
        setRepeatLesson(false)
        let myMap = {}
        for(let i = 0; i < props.fam.lessons.length; i++) {
            if(myMap[props.fam.lessons[i].date]) {
                if(myMap[props.fam.lessons[i].date][props.fam.lessons[i].studentName]) {
                    setRepeatLesson(true)
                } else {
                    myMap[props.fam.lessons[i].date][props.fam.lessons[i].studentName] = true
                }
            } else {
                myMap[props.fam.lessons[i].date] = {}
                myMap[props.fam.lessons[i].date][props.fam.lessons[i].studentName] = true
            }
        }
        for(let i = 0; i < props.fam.cancellations.length; i++) {
            if(myMap[props.fam.cancellations[i].date]) {
                if(myMap[props.fam.cancellations[i].date][props.fam.cancellations[i].student]) {
                    setRepeatLesson(true)
                } else {
                    myMap[props.fam.cancellations[i].date][props.fam.cancellations[i].student] = true
                }
            } else {
                myMap[props.fam.cancellations[i].date] = {}
                myMap[props.fam.cancellations[i].date][props.fam.cancellations[i].student] = true
            }
        }
    }

    const enterAdds = (e, index) => {
        if(e.key === 'Enter') {
            props.submitLastName(props.index)
        }
    }
    const removeUnderline = (value, id, num) => {
        if(value !== '') {
            document.getElementById(`${id}${num}`).style.border = "none"
            document.getElementById(`${id}${num}`).style.backgroundColor = "#fff"
        }
    }

    const chooseTheFamily = (obj) => {
        props.changeFamilyName(props.index, obj)
        setFamilyNameSuggestions([])
    }
    // const generateTeacherFilterList = () => {
    //     let listOfSchoolsFamilies = props.listOfFamilies
    //     let theList = document.getElementById(`family-selector-${props.fam.id}`)
    //     if(theList) {
    //         while(theList.hasChildNodes()) {
    //             theList.removeChild(theList.lastChild)
    //         }
    //         let theDefaultOption = document.createElement("option")
    //         theDefaultOption.value = "---"
    //         theDefaultOption.text = "Match Family"
    //         theList.appendChild(theDefaultOption)
    //         for(let i = 0; i < listOfSchoolsFamilies.length; i++) {
    //             let option = document.createElement("option")
    //             option.value = listOfSchoolsFamilies[i].waveCustomerId
    //             option.text = listOfSchoolsFamilies[i].familyName
    //             theList.appendChild(option)
    //         }
    //         if(props.fam.familyWaveId) {
    //             theList.value = props.fam.familyWaveId
    //         }
    //     }
    // }

    // const generateTeacherFilterListForTeachers = () => {
    //     let listOfSchoolsFamiliesForTeachers = props.listOfFamiliesForTeachers
    //     let theList = document.getElementById(`family-selector-${props.fam.id}-for-teacher`)
    //     if(theList) {
    //         while(theList.hasChildNodes()) {
    //             theList.removeChild(theList.lastChild)
    //         }
    //         let theDefaultOption = document.createElement("option")
    //         theDefaultOption.value = "---"
    //         theDefaultOption.text = "Choose Family"
    //         theList.appendChild(theDefaultOption)
    //         for(let i = 0; i < listOfSchoolsFamiliesForTeachers.length; i++) {
    //             let option = document.createElement("option")
    //             option.value = listOfSchoolsFamiliesForTeachers[i].Family
    //             option.text = listOfSchoolsFamiliesForTeachers[i].Family
    //             theList.appendChild(option)
    //         }
    //         if(props.fam.Family) {
    //             theList.value = props.fam.Family
    //         }
    //     }
    // }

    const searchDatabaseForFamilyName = (index, value) => {
        setSearchName(value)
        axios.get(`${baseUrl}/search/${value}`, myHeader)
        .then(res => {
            setFamilyNameSuggestions(res.data)
        })
        .catch(err => {
            console.log(err)
        })
    }

    const checkIfLessonLengthIsTheSameAsInTheDatabase = (studentName, length) => {
        if(props.reviewing) {
            for(let i = 0; i < props.fam.listOfFamilyStudents.length; i++) {
                if(studentName === props.fam.listOfFamilyStudents[i].studentName) {
                    if(parseInt(length) === props.fam.listOfFamilyStudents[i].lessonLength) {
                        return false
                    } else {
                        return true
                    }
                }
            }
        } else {
            return false
        }
    }

    const getFamilyInfoForPopupWindow = (waveId, bool) => {
        if(props.reviewing) {
            if(bool) {
                axios.get(`${baseUrl}/family-lookup/${waveId}`, myHeader)
                .then((res) => {
                    let studentsObjectList = []
                    for(let i = 0; i < res.data.students.length; i++) {
                        studentsObjectList.push({
                            id: Math.random().toString(16).slice(2),
                            Name: res.data.students[i].studentName,
                            Status: res.data.students[i].studentStatus,
                            Notes: res.data.students[i].studentNotes,
                            Length: res.data.students[i].lessonLength,
                        })
                    }
                    setFamilyInfoPopupData(studentsObjectList)
                })
                .catch((err) => {
                    console.log(err)
                })
            }
            setFamilyInfoPopup(bool)
        }
    }

    const generateWaveIdAndSetFamilyToActive = (familyEmail) => {
        document.body.style.cursor = 'wait'
        document.getElementById('family-card__generate-wave-id-btn').style.cursor = "wait"
        //GET FAMILY INFO FROM STUDENT DATABASE
        axios.get(`${baseUrl}/school-management-email/${familyEmail}`, myHeader)
        .then((res) => {
            //CREATE NEW WAVE USER
            makeANewWaveClient(res.data)
        })
        .catch((err) => {
            console.log(err)
            console.log('error on step 1')
        })
    }

    const makeANewWaveClient = async (theNewStudent) => {
        let businessId;
        let stateCode;

        //console.log(theNewStudent)

        if(theNewStudent.school === 'MMA') {
            businessId = "QnVzaW5lc3M6ZDVlMTRiODMtZDM1OC00MzVlLWI3ZWQtMzU2ZjAzNDAzYzBh"
            stateCode = 'US-CO'
        } else if (theNewStudent.school === 'LSMA') {
            businessId = "QnVzaW5lc3M6NGYxNWJhZGItYTc4Zi00ZjIxLWE2MDEtYmY0YjA2ZDVlNzk2"
            stateCode = 'US-MN'
        } else if (theNewStudent.school === 'TMA') {
            businessId = "QnVzaW5lc3M6OGMyMGUyN2YtZTQ2MC00ZGI2LWI1M2ItNGNhNzMxYTMyNDky"
            stateCode = 'US-MI'
        } else if (theNewStudent.school === 'MOR') {
            businessId = "QnVzaW5lc3M6MjgxYzUwZmQtMjg0Yi00MzMyLTk5NjEtN2Y3MjNkMDRkZmQw"
            stateCode = 'US-OR'
        } else if (theNewStudent.school === 'PSMA') {
            businessId = "QnVzaW5lc3M6YmY0MjEzYmYtYjEwYi00NmNhLTkyZTAtNjBiNTdmNDNlYzY5"
            stateCode = 'US-WA'
        } else {
            alert('Please choose a school!')
            return
        }

        let zipCodeString;
        if(theNewStudent.address.zipcode) {
            theNewStudent.address.zipcode.toString() === '0' ? zipCodeString = '' : zipCodeString = theNewStudent.address.zipcode.toString()
        } else {
            theNewStudent.address.zipcode = '0'
        }

      let createCustomerVariables = 
      {
          "input": {
            "businessId": businessId,
            "name": theNewStudent.familyName,
            "firstName": theNewStudent.primaryParentName,
            "lastName": theNewStudent.familyName,
            "email": theNewStudent.primaryEmail,
            "address": {
              "addressLine1": theNewStudent.address.addressLine1,
              "addressLine2": theNewStudent.address.addressLine2,
              "city": theNewStudent.address.city,
              "postalCode": zipCodeString,
              "provinceCode": stateCode,
              "countryCode": "US"
            },
            "currency": "USD"
          }
        }
        
        return createCustomer({variables: createCustomerVariables})
        .then((res) => {
            //SET FAMILY AND STUDENT(S) TO ACTIVE IN DATABASE
            axios.put(`${baseUrl}/school-management/${theNewStudent.familyId}`, {
                familyId: theNewStudent.familyId,
                familyName: theNewStudent.familyName,
                students: theNewStudent.students,
                primaryParentName: theNewStudent.primaryParentName,
                school: theNewStudent.school,
                address: theNewStudent.address,
                primaryEmail: theNewStudent.primaryEmail,
                primaryCellphone: theNewStudent.primaryCellphone,
                primaryHomePhone: theNewStudent.primaryHomePhone,
                familyNotes: theNewStudent.familyNotes,
                familyStatus: 'Active',
                hearOfUs: theNewStudent.hearOfUs,
                onboardDate: theNewStudent.onboardDate,
                waveCustomerId: res.data.customerCreate.customer.id
            }, myHeader)
            .then((res) => {
                //ADD WAVE ID TO TEACHERTIMESHEET
                props.updateFamiliesInDatabaseWithWaveId(res.data.primaryEmail, res.data.waveCustomerId, props.timesheet.timesheetId)
            })
            .catch((err) => {
                console.log(err)
                console.log('error on step 3')
            })
        })
        .catch((err) => {
            //setError(err)
            console.log(err.networkError.result.errors)
            console.log('error on step 2')
            return
        })
    }

    return(
        <div className="family-card" style={props.fam.familyWaveId === '' ? {backgroundColor: 'rgba(0, 0, 0, 0.03)'} : {backgroundColor: 'rgb(255, 255, 255)'}} >
            {props.fam.listOfFamilyStudents.length > 0 || props.fam._id
            ? 
                <div className="add-some-padding">
                    {familyInfoPopup && props.reviewing ? <div className="timesheet-family-info-popup">{familyInfoPopupData.map((obj) => <div className="timesheet-family-info__each-student" key={obj.id}><p className="timesheet-family-info__each-student__student-name">{obj.Name}:</p><p className="timesheet-family-info__each-student__student-status">{obj.Status}</p><p className="timesheet-family-info__each-student__student-length">{obj.Length} min</p>{obj.Notes !== '' && <p className="timesheet-family-info__each-student__student-notes">{obj.Notes}</p>}</div>)}</div> : null}
                    <h3 className="family-card__family-name" onMouseEnter={() => getFamilyInfoForPopupWindow( props.fam.familyWaveId, true)} onMouseLeave={() => getFamilyInfoForPopupWindow( props.fam.familyWaveId, false)}>{props.fam.familyName}</h3>
                    <p className="family-card__delete-btn" onClick={() => props.removeFamily(props.fam.id)}>delete</p>
                    {
                        props.reviewing && props.fam.familyWaveId === '' && 
                        <div className='family-card__wave-id-popup__wrapper'>
                            <div className='family-card__wave-id-btn__explanation'>This family needs a Wave ID. Please click button before approving the timesheet.</div>
                            <div id="family-card__generate-wave-id-btn" className="family-card__generate-wave-id-btn" onClick={() => generateWaveIdAndSetFamilyToActive(props.fam.email)}>Create Wave ID</div>
                        </div>
                            // <select className="family-selector" id={`family-selector-${props.fam.id}`} value={props.fam.familyWaveId} onChange={(e) => props.addWaveIdToFamilyInformation(props.timesheet.timesheetId, props.fam.id, e.target.value)}>
                            //     <option value="" default>Match Family</option>
                            // </select>
                    }
                    {props.reviewing && repeatLesson &&
                        <div className='family-card__double-check-for-repeat-lesson__wrapper'>
                            <div className='family-card__double-check-for-repeat-lesson'>REPEAT LESSON WARNING</div>
                        </div>
                    }
                    {
                        props.fam.lessons.map((less, index2) => 
                            <div className="family-card__each-lesson-wrapper" key={index2}>
                                <p className="student-remove-x" onClick={() => props.removeLesson(props.index, less.id, index2)}>x</p>
                                {
                                    less.enterNameManually || props.fam.listOfFamilyStudents.length < 1 ?
                                    <input className="manual-student-input" placeholder="Student's Name" value={less.studentName} id={`${less.id}1`} onBlur={(e) => removeUnderline(e.target.value, less.id, '1')} onChange={(e) => props.editLesson(props.index, index2, e.target.value, 'studentName')} />
                                    :
                                     <select className="choose-student-input-dropdown" value={less.studentName} placeholder="Student" id={`${less.id}1`} onBlur={(e) => removeUnderline(e.target.value, less.id, '1')} onChange={(e) => props.editLesson(props.index, index2, e.target.value, 'studentName')} >
                                        <option value="" default>Choose Student</option>
                                        {
                                            props.fam.listOfFamilyStudents.map((student) => (
                                                <option key={student.studentId} value={student.studentName}>{student.studentName}</option>
                                            ))
                                        }
                                        {/* {props.reviewing && <option value={less.studentName}>{less.studentName}</option>} */}
                                        <option value="*">Enter Manually</option>
                                    </select>
                                }
                                <div className="family-card__lesson-date">{props.month}/<input value={less.date} id={`${less.id}2`} onBlur={(e) => removeUnderline(e.target.value, less.id, '2')} onChange={(e) => props.editLesson(props.index, index2, e.target.value, 'date')} className="lesson-date-input" />/22</div>
                                <select onChange={(e) => props.editLesson(props.index, index2, e.target.value, 'lessonLength')} id={`${less.id}3`} onBlur={(e) => removeUnderline(e.target.value, less.id, '3')} value={less.lessonLength} className="family-card__lesson-length" style={(props.reviewing && (less.lessonLength === 0 || less.lessonLength === '0')) ? {border: "3px solid orange", animation: 'inNout 800ms linear infinite'} : {border: 'none'}}>
                                    <option default value={0}>Length</option>
                                    <option value="15">15 min</option>
                                    <option value="30">30 min</option>
                                    <option value="45">45 min</option>
                                    <option value="60">60 min</option>
                                </select>
                                {checkIfLessonLengthIsTheSameAsInTheDatabase(less.studentName, less.lessonLength) && <div onMouseEnter={() => setLengthWarningPopup(true)} onMouseLeave={() => setLengthWarningPopup(false)} className='family-card__lessons-wrong-length-warning'>!</div>}
                                {lengthWarningPopup && <WrongLessonLengthWarningPopup />}
                            </div>
                        )
                    }
                    {props.fam.cancellations.length > 0 && <div className="lesson-header">Cancellations</div>}
                    {
                        props.fam.cancellations.map((cancel, index2) => 
                            <div className="family-card__each-lesson-wrapper go-red" key={cancel.id}>
                                <p className="student-remove-x" onClick={() => props.removeCancellation(props.index, cancel.id)}>x</p>
                                {cancel.enterNameManually || props.fam.listOfFamilyStudents < 1 ?
                                <input className="manual-student-input go-red" value={cancel.student} placeholder="Student" id={`${cancel.id}1`} onBlur={(e) => removeUnderline(e.target.value, cancel.id, '1')} onChange={(e) => props.editCancellation(props.index, index2, e.target.value, 'student')} /> :
                                <select className="choose-student-input-dropdown go-red"  value={cancel.student} placeholder="Student" id={`${cancel.id}1`} onBlur={(e) => removeUnderline(e.target.value, cancel.id, '1')} onChange={(e) => props.editCancellation(props.index, index2, e.target.value, 'student')} >
                                    <option value="" default>Choose Student</option>
                                    {props.fam.listOfFamilyStudents.map((student) => (
                                        <option key={student.studentId} value={student.studentName}>{student.studentName}</option>
                                    ))}
                                    {/* {props.reviewing && <option value={cancel.student}>{cancel.student}</option>} */}
                                    <option value="*">Enter Manually</option>
                                </select>
                                }
                                <div className="family-card__lesson-date go-red">{props.month}/<input value={cancel.date} id={`${cancel.id}2`} onBlur={(e) => removeUnderline(e.target.value, cancel.id, '2')} onChange={(e) => props.editCancellation(props.index, index2, e.target.value, 'date')} className="lesson-date-input go-red" />/22</div>
                                <select value={cancel.cancellor} onChange={(e) => props.editCancellation(props.index, index2, e.target.value, 'cancellor')} id={`${cancel.id}4`} onBlur={(e) => removeUnderline(e.target.value, cancel.id, '4')} className="family-card__lesson-length cancellation-selector go-red">
                                    <option default value="0">Cancelled by</option>
                                    <option value="student">Student</option>
                                    <option value="teacher">Teacher</option>
                                    <option value="student less than 24hrs">Student&lt;24hr</option>
                                    {props.reviewing && <option value="sus-cancellation">Suspected Cancellation</option>}
                                </select>
                                { cancel.cancellor === "student less than 24hrs" ?
                                    <select onChange={(e) => props.editCancellation(props.index, index2, e.target.value, 'lessonLength')} id={`${cancel.id}3`} onBlur={(e) => removeUnderline(e.target.value, cancel.id, '3')} value={cancel.lessonLength} className="family-card__lesson-length popup-length-option go-red">
                                        <option default value={0}>Select Lesson Length</option>
                                        <option value="15">15 min</option>
                                        <option value="30">30 min</option>
                                        <option value="45">45 min</option>
                                        <option value="60">60 min</option>
                                    </select>
                                    :
                                    null
                                }
                            </div>
                        )
                    }
                    {props.fam.extras.length > 0 && <div className="lesson-header">Extras</div>}
                    {
                        props.fam.extras.map((extra, index2) => 
                            <div className="family-card__each-lesson-wrapper" key={extra.id}>
                                <p className="student-remove-x" onClick={() => props.removeExtra(props.index, extra.id)}>x</p>
                                <input className="family-card__student-name" value={extra.description} placeholder="Description" id={`${extra.id}1`} onBlur={(e) => removeUnderline(e.target.value, extra.id, '1')} onChange={(e) => props.editExtra(props.index, index2, e.target.value, 'description')} />
                                <div className="family-card__lesson-date">$<input value={extra.amount} className="lesson-date-input" id={`${extra.id}2`} onBlur={(e) => removeUnderline(e.target.value, extra.id, '2')} onChange={(e) => props.editExtra(props.index, index2, e.target.value, 'amount')} /></div>
                            </div>
                        )
                    }
                    <h5 className="family-card__add-lesson" onClick={() => props.addLesson(props.index)}>+ Lesson</h5>
                    <h5 className="family-card__add-cancellation" onClick={() => props.addCancellation(props.index)}>+ Cancellation</h5>
                    <h5 className="family-card__add-extra" onClick={() => props.addExtra(props.index)}>+ Extra</h5>
                </div>
            :
            <div className="add-some-padding">
                {/* {
                    manuallyEnterFamilyName ?  */}
                        <div>
                            <div className="manually-enter-family-name">
                                <p className="back-to-dropdown-x" onClick={() => props.removeFamily(props.fam.id)}>x</p>
                                <input className="manually-enter-family-name-input" placeholder="Enter Family Name" value={searchName} onKeyDown={(e) => enterAdds(e, props.index)} onChange={(e) => searchDatabaseForFamilyName(props.index, e.target.value)} />
                            </div>
                            {familyNameSuggestions.length > 0 &&
                                <div className="manually-enter-family__suggestion-box">
                                    {familyNameSuggestions.map((sugg) => (
                                        <h5 className="manually-enter-family__family-suggestions" key={sugg._id} onClick={() => chooseTheFamily(sugg)}>{sugg.primaryParentName} {sugg.familyName}</h5>
                                    ))}
                                </div>
                            }
                        </div>
                {/* //     :
                //     <div>
                //     {   
                        props.reviewing ?
                            <select className="family-selector-for-teacher" id={`family-selector-${props.fam.id}-for-teacher`} value={props.fam.familyName} onChange={(e) => props.autoOpenFamilyCardWhenNameIsSelected(props.index, e.target.value)} >
                                <option value="" default>Choose Family</option>
                                {
                                    props.listOfFamilies.map((family) => (
                                        <option key={family.familyName} value={family.familyName}>{family.familyName}</option>
                                    ))
                                }
                                <option value="*">Enter Manually</option>    
                            </select>
                        :
                            <select className="family-selector-for-teacher" id={`family-selector-${props.fam.id}-for-teacher`} value={props.fam.familyName} onChange={(e) => props.autoOpenFamilyCardWhenNameIsSelected(props.index, e.target.value)} >
                                <option value="" default>Choose Family</option>
                                {
                                    props.listOfFamiliesForTeachers.map((family) => (
                                        <option key={family.familyName} value={family.familyName}>{family.familyName}</option>
                                    ))
                                }
                                <option value="*">Enter Manually</option>    
                            </select>
                    }
                    </div>
                } */}
            </div>
            }
        </div>
    )
}
export default FamilyCard;